var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content__container"},[_c('div',{staticClass:"html__content",domProps:{"innerHTML":_vm._s(_vm.$store.getters.GET_LANG ? _vm.contentBlock.text : _vm.contentBlock.text_eng)}}),_c('img',{attrs:{"src":_vm.contentBlock.image && _vm.contentBlock.image.length ? _vm.contentBlock.image[0] : ''},on:{"click":_vm.setLightBox}})])
}
var staticRenderFns = []

export { render, staticRenderFns }